export async function parseErrorMessage(res, operation) {
  const text = await res.text().catch(() => '');
  let detail;
  try {
    const j = JSON.parse(text);
    detail = j?.message || null;       // JSON valido ma senza message → null (non usiamo il JSON grezzo)
  } catch {
    detail = text || null;             // Non è JSON → testo plain (es. "Unauthorized")
  }
  if (!detail) detail = 'Errore di comunicazione';
  const msg = `${detail} (${res.status})`;
  return operation ? `${operation}: ${msg}` : msg;
}
